import { isEmpty } from "lodash-es";
import { useIntl } from "react-intl";
import type { InfinitySelectOption } from "~components/InfinitySelect";
import { SelectVenue } from "~components/SelectVenue/SelectVenue";
import type { Venue } from "~types/venue";
import { useUpdateListFixture } from "../../hooks";
import type { ColumnComponentProperties } from "../../types";

interface IVenueColumnProperties extends ColumnComponentProperties {
  venue: Venue;
}

export const VenueColumn = (properties: IVenueColumnProperties) => {
  const { formatMessage } = useIntl();
  const { mutate: updateFixture, isPending: isLoading } = useUpdateListFixture();

  if (properties.editMode) {
    const value = isEmpty(properties.venue)
      ? null
      : {
          label: properties.venue.nameLocal,
          value: properties.venue.venueId,
        };

    const onChangeHandler = (venueOption: InfinitySelectOption | null) =>
      updateFixture({
        fixtureId: properties.fixtureId,
        upsertData: {
          venueId: venueOption?.value ? venueOption?.value : null,
        },
      });

    return (
      <SelectVenue
        disabled={isLoading}
        placeholder={formatMessage({
          id: "fixtureListPage.table.column.editMode.venue.placeholder",
        })}
        value={value}
        onChange={onChangeHandler}
      />
    );
  }

  return properties.venue?.nameLocal;
};
